import React from 'react';
import Backend from '../../../../Layouts/Backend';
import Loading from '../../../../Helpers/Loading';
import EditRemoteDevicePage from './EditRemoteDevicePage';
import { connect } from 'react-redux';
import { configureActions } from '../../../../../actions/configure.action';
import helper from '../../../../../utils/helper';
import lookupActions from '../../../../../actions/lookup.actions';
import { bindActionCreators } from 'redux';

class EditRemoteDevice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      remoteDevice: {},
      getRemoteDeviceError: {},
      departments: [],
      loading: false,
      errors: '',
      isSubmitting: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    // if (nextProps.configure.remoteDevice !== prevState.remoteDevice) {
    //   state.remoteDevice = nextProps.configure.remoteDevice;
    // }
    if (nextProps.lookup.departments !== prevState.departments) {
      state.departments = nextProps.lookup.departments;
    }
    if (
      nextProps.configure.getRemoteDeviceError !==
      prevState.getRemoteDeviceError
    ) {
      state.getRemoteDeviceError = nextProps.configure.getRemoteDeviceError;
    }
    state.errors = helper.centralizeError([
      nextProps.configure.errors,
      nextProps.lookup.errors,
    ]);
    if (nextProps.configure.isSubmitting !== prevState.isSubmitting) {
      state.isSubmitting = nextProps.configure.isSubmitting;
    }
    if (nextProps.configure.loading !== prevState.loading) {
      state.loading = nextProps.configure.loading;
    }
    return Object.keys(state).length ? state : null;
  }

  async componentDidMount() {
    const { id } = this.props.match.params;
    await this.props.lookupActions.getDepartments();
    this.props.configureActions
      .getSpecificRemoteDevice(id)
      .then((resp) => this.setState({ remoteDevice: resp }))
      .catch((err) => console.log(err));
  }

  onEditRemoteDevice = (params) => {
    const { id } = this.props.match.params;
    this.props.configureActions
      .editRemoteDevice(id, params)
      .then(() => this.props.history.goBack())
      .catch((err) => console.log(err));
  };

  render() {
    const { remoteDevice, departments, loading } = this.state;
    if (loading) {
      <Backend>
        <Loading />
      </Backend>;
    }
    if (Object.keys(remoteDevice).length && departments.length) {
      const departmentName = departments.filter(
        (dept) => dept.id === remoteDevice.deptId,
      )[0].name;
      remoteDevice.departmentName = departmentName;
    }
    return (
      <EditRemoteDevicePage
        {...this.state}
        onEditRemoteDevice={this.onEditRemoteDevice}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
    lookup: state.lookup,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(EditRemoteDevice);
